import React from "react";

export const Team = ({ data }) => {
  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Meet the Team</h2>
          <p>
            Our leadership team combines decades of experience, innovation, and
            industry expertise to deliver exceptional technology solutions.
          </p>
        </div>

        <div className="row">
          {data
            ? data.map((member, i) => (
                <div key={i} className="col-md-4 col-sm-6 team">
                  <div className="thumbnail">
                    <img
                      src={member.img}
                      alt={member.name}
                      className="team-img"
                    />
                    <div className="caption">
                      <h4>{member.name}</h4>
                      <p className="job-title">{member.job}</p>
                      <p className="description">{member.description}</p>

                      {/* Social media links */}
                      <div className="social">
                        {member.facebook && (
                          <a href={member.facebook} target="_blank" rel="noreferrer">
                            <i className="fa fa-facebook"></i>
                          </a>
                        )}
                        {member.twitter && (
                          <a href={member.twitter} target="_blank" rel="noreferrer">
                            <i className="fa fa-twitter"></i>
                          </a>
                        )}
                        {member.linkedin && (
                          <a href={member.linkedin} target="_blank" rel="noreferrer">
                            <i className="fa fa-linkedin"></i>
                          </a>
                        )}
                        {member.instagram && (
                          <a href={member.instagram} target="_blank" rel="noreferrer">
                            <i className="fa fa-instagram"></i>
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
